<template>
	<div>
		<!-- <NuxtRouteAnnouncer /> -->
		<NuxtLoadingIndicator color="var(--color-primary-400)" />
		<UApp :toaster="toaster">
			<NuxtLayout>
				<NuxtPage />
			</NuxtLayout>
		</UApp>
	</div>
</template>

<script setup>
const toaster = { position: 'bottom-right' }
const { public: { gtmId } } = useRuntimeConfig()

useHead({
    noscript: [{
        key: 'gtm-noscript',
        innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        tagPosition: 'bodyOpen',
    }],
})
</script>